(() => {
  if (window.teCatalogueBound) return;
  window.teCatalogueBound = true;
  const productRoot = (target) => target.closest('product-info[data-te-require-size]');
  const showSizeError = (root, quiet = false) => {
    const note = root.querySelector('[data-te-size-message]');
    if (note) { note.textContent = root.dataset.teSizeMessage; note.hidden = quiet; }
    const size = root.querySelector('[data-te-size-option] input, [data-te-size-option] button');
    size?.focus({ preventScroll: true });
    root.querySelector('[data-te-size-option]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const barButton = root.querySelector('[data-cart-bar-add-to-cart]');
    barButton?.classList.remove('is-loading');
  };
  document.addEventListener('click', (event) => {
    const familyLink = event.target.closest('a[data-te-family]');
    if (familyLink) {
      const url = new URL(location.href);
      url.searchParams.delete('filter.p.product_type');
      url.searchParams.set('filter.p.product_type', familyLink.dataset.teFamily);
      url.searchParams.delete('page');
      familyLink.href = url.pathname + url.search;
      return;
    }
    const thumbnail = event.target.closest('[data-te-media-id]');
    if (thumbnail) {
      const gallery = thumbnail.closest('[data-product-single-media-group]');
      const slider = gallery?.querySelector('[data-product-single-media-slider]');
      const instance = window.theme?.Flickity?.data(slider);
      const slides = Array.from(slider?.querySelectorAll('[data-product-slide]') || []);
      const index = slides.findIndex((slide) => slide.dataset.id === thumbnail.dataset.teMediaId);
      if (instance && index >= 0) {
        event.preventDefault();
        instance.select(index);
        gallery.querySelectorAll('[data-te-media-id]').forEach((link) => {
          if (link === thumbnail) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }
      return;
    }
    const root = productRoot(event.target);
    if (!root) return;
    if (event.target.closest('[data-te-size-option] label, [data-te-size-option] input, [data-te-size-option] [data-popout-option]')) {
      root.dataset.teRequireSize = 'false';
      const note = root.querySelector('[data-te-size-message]');
      if (note) note.hidden = true;
      return;
    }
    if (root.dataset.teRequireSize === 'true' && event.target.closest('[data-add-to-cart], [data-cart-bar-add-to-cart]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const mobileChooser = event.target.closest('cart-bar[data-te-early-mobile]') && window.matchMedia('(max-width: 767px)').matches;
      showSizeError(root, mobileChooser);
    }
  }, true);
  document.addEventListener('submit', (event) => {
    const root = productRoot(event.target);
    if (root?.dataset.teRequireSize === 'true' && event.target.matches('[data-product-form]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showSizeError(root);
    }
  }, true);
  document.addEventListener('change', (event) => {
    const root = productRoot(event.target);
    if (root && event.target.closest('[data-te-size-option]')) {
      root.dataset.teRequireSize = 'false';
      const note = root.querySelector('[data-te-size-message]');
      if (note) note.hidden = true;
    }
  }, true);
  const updateAvailability = (root, variant) => {
    const note = root.querySelector('[data-te-unavailable-note]');
    if (!note) return;
    note.hidden = root.dataset.teRequireSize === 'true' || !variant || variant.available;
    const link = note.querySelector('[data-te-availability-link]');
    if (link && variant) {
      const url = new URL('/pages/contact', location.origin);
      url.searchParams.set('product', root.dataset.productHandle);
      url.searchParams.set('variant', variant.id);
      link.href = url.pathname + url.search;
    }
  };
  document.addEventListener('theme:variant:prices-updated', (event) => {
    const root = event.target.closest('product-info[data-te-require-size]');
    if (root) updateAvailability(root, event.detail?.variant);
  });
  const galleryObservers = new WeakMap();
  const initGallery = (root) => {
    const gallery = root.querySelector('[data-product-single-media-group]');
    const slider = gallery?.querySelector('[data-product-single-media-slider]');
    if (!slider || galleryObservers.has(slider)) return;
    let activeMediaId = '';
    const sync = () => {
      const selected = slider.querySelector('[data-product-slide].is-selected');
      if (!selected) return;
      if (activeMediaId === selected.dataset.id) return;
      activeMediaId = selected.dataset.id;
      const selectedLink = Array.from(gallery.querySelectorAll('[data-te-media-id]')).find((link) => link.dataset.teMediaId === activeMediaId);
      gallery.querySelectorAll('[data-te-media-id]').forEach((link) => {
        if (link === selectedLink) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      const pill = gallery.querySelector('[data-te-model-fit-pill]');
      if (!pill) return;
      const image = selected.querySelector('img');
      const file = selectedLink?.getAttribute('href') || image?.currentSrc || image?.getAttribute('src') || '';
      const label = selectedLink?.getAttribute('aria-label') || image?.alt || '';
      const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const filename = normalize(file.split('/').pop()?.split('?')[0] || '');
      const description = normalize(label);
      const hasWord = (value, word) => new RegExp(`(?:^|[^a-z])${word}(?:$|[^a-z])`).test(value);
      const isDetail = /detail|fiche|descriptif|texture|packshot/.test(`${filename} ${description}`);
      let gender = '';
      if (!isDetail) {
        if (hasWord(filename, 'femme')) gender = 'woman';
        else if (hasWord(filename, 'homme')) gender = 'man';
        else if (hasWord(description, 'femme')) gender = 'woman';
        else if (hasWord(description, 'homme')) gender = 'man';
        else if (gallery.dataset.tePrimaryModelMediaId && selectedLink?.dataset.teMediaId === gallery.dataset.tePrimaryModelMediaId) gender = 'man';
      }
      const fit = gender === 'woman' ? pill.dataset.teModelFitWoman : gender === 'man' ? pill.dataset.teModelFitMan : '';
      pill.hidden = !fit;
      if (fit) {
        pill.querySelector('[data-te-model-fit-text]').textContent = fit;
        pill.setAttribute('aria-label', `Repère de taille : ${fit}`);
      }
    };
    const observer = new MutationObserver(sync);
    observer.observe(slider, { subtree: true, attributes: true, attributeFilter: ['class'] });
    galleryObservers.set(slider, observer);
    sync();
  };
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-product-single-media-slider]').forEach((slider) => {
      galleryObservers.get(slider)?.disconnect();
      galleryObservers.delete(slider);
    });
  });
  const init = () => document.querySelectorAll('product-info[data-te-require-size]').forEach((root) => {
    initGallery(root);
    try { updateAvailability(root, JSON.parse(root.querySelector('[data-selected-variant]')?.textContent || 'null')); } catch (_) {}
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('theme:product-info:loaded', init);
  const key = () => `te-collection-scroll:${location.pathname}${location.search}`;
  document.addEventListener('click', (event) => {
    if (event.target.closest('.te-catalogue a[href*="/products/"]')) {
      try { sessionStorage.setItem(key(), String(window.scrollY)); } catch (_) {}
    }
  });
  window.addEventListener('pageshow', (event) => {
    if (!document.querySelector('.te-catalogue') || event.persisted) return;
    const navigation = performance.getEntriesByType('navigation')[0];
    if (navigation?.type !== 'back_forward') return;
    try {
      const saved = Number(sessionStorage.getItem(key()));
      if (saved > 0) requestAnimationFrame(() => window.scrollTo(0, saved));
    } catch (_) {}
  });
})();
